import { METHOD } from './method'

export const API_DEVELOPMENT_SUMMARY = {
    LIST: {
        api: '/v1/hr-adm/hr-metrics/development-summary',
        method: METHOD.GET,
    },
    CREATE_PERIOD: {
        api: '/v1/hr-adm/hr-metrics/development-summary/periods',
        method: METHOD.POST,
    },

    DETAIL: {
        api: '/v1/hr-adm/hr-metrics/development-summary',
        method: METHOD.POST,
    },
    EXPORT: {
        api: '/v1/hr-adm/hr-metrics/development-summary/export',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/hr-adm/hr-metrics/development-summary',
        method: METHOD.PUT,
    },
    DELETE: {
        api: '/v1/hr-adm/hr-metrics/development-summary',
        method: METHOD.DELETE,
    },
    SYNC: {
        api: '/v1/hr-adm/hr-metrics/development-summary/sync',
        method: METHOD.POST,
    },
    URL_DOCUMENT: {
        api: '/v1/hr-adm/hr-metrics/development-summary/storage-url/document',
        method: METHOD.POST,
    },
    UPLOAD_DOCUMENT: {
        api: '/v1/hr-adm/hr-metrics/development-summary/upload-file',
        method: METHOD.POST,
    },
    LIST_DEPARTMENT: {
        api: '/v1/hr-adm/hr-metrics/development-summary/departments',
        method: METHOD.POST,
    },
    LIST_DIVISION: {
        api: '/v1/hr-adm/hr-metrics/development-summary/divisions',
        method: METHOD.POST,
    },

    DOWNLOAD_TEMPLATE: {
        api: '/v1/hr-adm/hr-metrics/development-summary/import/download-template',
        method: METHOD.GET,
    },
    FILE_VALIDATION: {
        api: '/v1/hr-adm/hr-metrics/development-summary/import/validate',
        method: METHOD.POST,
    },
    IMPORT: {
        api: '/v1/hr-adm/hr-metrics/development-summary/import/process',
        method: METHOD.POST,
    },
}
